<template>
    <LayoutDefault>
        <div id="searcher" class="container">
            <FiltersContainer v-if="filtersActive" @filter="setFilters" />

            <div class="mode-switch-container">
                <div class="mode-switch-btn divas" avoid-theme @click="setType('divas')">Divas</div>
                <div class="mode-switch-btn chads" avoid-theme @click="setType('chads')">Chads</div>
            </div>

            <div class="content">
                <GridModelsContainer :error-models="errorModels" :load-models="loadModels"
                    :loading-models="loadingModels" :models="webstars" />
            </div>
        </div>
    </LayoutDefault>
</template>

<script>
import resources from '../resources';
import LayoutDefault from "../layouts/LayoutDefault2021";
import FiltersContainer from "../components/Filters/FiltersContainer";
import GridModelsContainer from "../components/GridModelsContainer";
import ThemeManager from "../modules/ThemeManager/ThemeManager";

export default {
    components: {
        GridModelsContainer,
        LayoutDefault,
        FiltersContainer,
    },
    data() {
        return {
            filtersActive: process.env.VUE_APP_ACTIVE_FILTERS === 'true' || false,
            loadingModels: true,
            errorModels: false,
            models: null,
            currentFetchId: null,
        }
    },
    methods: {
        loadModels() {
            const request = {
                per_page: 40,
                priority: 1,
                page: 1,
                webstars: true,
                outstanding: false
            }
            this.searchModels(request);
        },
        setFilters(request) {
            request.per_page = 40;
            request.page = 1;
            request.webstars = true;
            request.outstanding = false;
            this.searchModels(request);
        },
        searchModels(request) {
            this.loadingModels = true;
            this.errorModels = false;
            this.models = null;
            request.text = this.$route.query.search;

            const fetchId = Math.random();
            this.currentFetchId = fetchId;
            resources.homepageModels.index(request)
                .then((response) => {
                    if (fetchId !== this.currentFetchId) return;
                    this.errorModels = false;
                    this.loadingModels = false;
                    this.models = response.data.data;
                }).catch(() => {
                    this.loadingModels = false;
                    this.errorModels = true;
                });
        },
        setType(type) {
            ThemeManager.setTheme(type); // Cambiar el tipo de sitio
            this.currentFetchId = null;
            this.loadModels();
        }
    },
    computed: {
        webstars() {
            if (!this.models) return [];

            const siteType = ThemeManager.getTheme();
            switch (siteType) {
                case 'divas':
                    return this.models.filter(model => model.sex === 'F' || model.sex === 'X');
                case 'chads':
                    return this.models.filter(model => model.sex === 'M' || model.sex === 'X');
            }
        }
    },
    mounted() {
        this.loadModels();
    },
    watch: {
        $route: function() {
            this.loadModels();
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.container {
    background-color: var(--pallete_dark_color);

    #searcher {
        margin-top: 100px;
    }

    .error {
        text-align: center;
    }

    .content {
        padding: 9px;
        margin-top: 10px;
    }
}
.mode-switch-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 15px 0 0 0;

    ::selection {
        background: transparent;
    }

    .mode-switch-btn {
        width: 30%;
        min-width: 225px;
        line-height: 2;
        text-align: center;
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;
        transition: all 200ms ease-in-out;
        padding: unset;
        border-radius: unset;
        color: var(--pallete_over_main_text_color);

        @media (max-width: 480px) {
            width: 49.5%;
            min-width: 150px;
            font-size: small;
        }

        &.divas[avoid-theme] {
            background: transparent;
            background-image: none;
            border-color: $DIVAS-PALLETE_MAIN_COLOR;
            background-color: lighten($DIVAS-PALLETE_MAIN_COLOR, 10%);

            &.active {
                background-color: $DIVAS-PALLETE_MAIN_COLOR;
                color: $DIVAS-PALLETE_OVER_MAIN_TEXT_COLOR;
            }

            &:hover {
                background-color: lighten($DIVAS-PALLETE_MAIN_COLOR, 5%);
                color: $DIVAS-PALLETE_OVER_MAIN_TEXT_COLOR;
            }
        }

        &.chads[avoid-theme] {
            background: transparent;
            background-image: none;
            border-color: $CHAD-PALLETE_MAIN_COLOR;
            background-color: lighten($CHAD-PALLETE_MAIN_COLOR, 15%);

            &.active {
                background-color: $CHAD-PALLETE_MAIN_COLOR;
                color: $CHAD-PALLETE_OVER_MAIN_TEXT_COLOR;
            }

            &:hover {
                background-color: lighten($CHAD-PALLETE_MAIN_COLOR, 7.5%);
                color: $CHAD-PALLETE_OVER_MAIN_TEXT_COLOR;
            }
        }
    }
}
</style>
